import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';

import { DropdownItem } from 'buyside/components/presentation/MainSiteNavigation/SideNavigation/SideNavigationDropdown/sideNavigationDropdown';

import { isActiveTab } from 'buyside/util/mainSiteNavigationPathHelper';

import styles from './sideNavigationDropdownStyles.scss';

const SideNavigationDropdownItem: React.FC<{
  dropdownItem: DropdownItem;
}> = ({ dropdownItem }) => {
  const { analyticsTag, disabled, icon, name, url } = dropdownItem;

  const Icon = icon;

  if (disabled)
    return (
      <div
        className={classNames(styles.dropdownItem, styles.disabled)}
        data-testid={`${name}-disabled`}
      >
        <FontAwesomeIcon icon={faLock} />
        {name}
      </div>
    );

  const active = isActiveTab(url);

  return (
    <a
      data-heap={analyticsTag}
      href={url}
      className={classNames(styles.dropdownItem, { [styles.active]: active })}
    >
      <Icon />
      {name}
    </a>
  );
};

export default SideNavigationDropdownItem;
